module.exports = MaterialUI.TableCell;